import React, { memo } from 'react'
import cn from 'classnames'

interface IProps {
  hasInfinityScroll?: boolean
  isLoading?: boolean
  loadingMessage?: string
  noOptionsMessage?: string
  optionsLength?: number
  showTotal?: boolean
  total?: number
}

const BaseOptionListFooter = ({
  optionsLength = 0,
  total,
  loadingMessage = 'Загружаем...',
  noOptionsMessage,
  isLoading,
  hasInfinityScroll
}: IProps) => {
  const className = cn(
    'flex-[1_0] text-body-sm text-on-surface/disabled flex flex-row md:pt-1 md:px-3 md:pb-0.5 md:border-none md:min-h-full',
    'py-2 px-4 min-h-[57px] border-t border-t-outline border-solid'
  )

  if (!isLoading && optionsLength === 0) {
    return noOptionsMessage ? (
      <p className={cn(className, '!text-body-md md:!text-body-sm')}>{noOptionsMessage}</p>
    ) : null
  }

  if (isLoading) {
    return <p className={className}>{loadingMessage}</p>
  }

  if (hasInfinityScroll) {
    return (
      <p className={className}>
        Загружено {optionsLength} из {total}
      </p>
    )
  }

  if (total && optionsLength < total) {
    return (
      <p className={className}>
        Загружено {optionsLength} из {total}.
        <br />
        Уточните запрос, чтобы увидеть остальные.
      </p>
    )
  }

  return null
}

export const OptionListFooter = memo(BaseOptionListFooter) as typeof BaseOptionListFooter
